import { BehaviorSubject } from 'rxjs';

export class SelectableActionsState {
  public all$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public selected$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  get all(): boolean {
    return this.all$.getValue();
  }

  set all(value: boolean) {
    this.all$.next(value);
  }

  get selected(): boolean {
    return this.selected$.getValue();
  }

  set selected(value: boolean) {
    this.selected$.next(value);
  }

  public reset() {
    this.all = false;
    this.selected = false;
  }
}
